import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { ErrorResponseNdcTechnicalFaqPage } from 'src/app/model/page/group/faq/error-response-ndc-technical-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-error-response-ndc-technical-faq-page',
  templateUrl: './error-response-ndc-technical-faq-page.component.html',
  styleUrls: ['./error-response-ndc-technical-faq-page.component.scss']
})
export class ErrorResponseNdcTechnicalFaqPageComponent implements OnInit {
  param: number = -1;
  errorResponseNdcTechnicalPage: ErrorResponseNdcTechnicalFaqPage = {} as ErrorResponseNdcTechnicalFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-technical-error-response') {
        this.errorResponseNdcTechnicalPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => (this.param = params['param']));

    this.errorResponseNdcTechnicalPage.sections = [];

    const query = { 'fields.title': 'NDC Technical FAQ#Error Responses' };
    this.contentfulService.getPageContentWithEntries(query).then((ErrorResponseNdcTechnicalPageEntries) => {
      this.mapBanner(ErrorResponseNdcTechnicalPageEntries);
      this.mapSections(ErrorResponseNdcTechnicalPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.errorResponseNdcTechnicalPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }

  private mapBanner(errorResponseNdcTechnicalPageEntries: Entry<any>[]) {
    errorResponseNdcTechnicalPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.errorResponseNdcTechnicalPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapSections(errorResponseNdcTechnicalPageEntries: Entry<any>[]) {
    errorResponseNdcTechnicalPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.errorResponseNdcTechnicalPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    // console.log(entry);

    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#')[2];

    this.errorResponseNdcTechnicalPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
